import Heading from 'components/universal/heading';
import Paragraph from 'components/universal/paragraph';
import React from 'react';
import cls from './unauthorized-user.module.scss';
import doctorWorkingOnPcImg from 'assets/images/disinfection-techniques/doctor-working-on-pc.png';
import { CustomLink } from 'components/universal/custom-link';
import { PATHS } from 'constants/routes';
import { useTranslation } from 'react-i18next';

export const UnauthorizedUser = () => {
    const { t } = useTranslation();
    return (
        <div className={cls.container}>
            <div className={cls.content}>
                <Heading
                    headingLevel="h1"
                    headingStyle="h3"
                    className={cls.header}
                >
                    {t('disinfectionTechnique.unauthorizedUser.title')}
                </Heading>
                <Paragraph className={cls.desc}>
                    {t('disinfectionTechnique.unauthorizedUser.desc')}
                </Paragraph>
                <CustomLink to={PATHS.LOGIN} className={cls.btn}>
                    {t('disinfectionTechnique.unauthorizedUser.link')}
                </CustomLink>
            </div>

            <figure className={cls.image}>
                <img src={doctorWorkingOnPcImg} alt="" />
            </figure>
        </div>
    );
};
